import { withDevtools, withGlitchTracking } from '@angular-architects/ngrx-toolkit';
import { computed } from '@angular/core';
import {
  CrewDashboardState,
  INITIAL_CREW_DASHBOARD_STATE,
} from '@navstation-portal/reporting/data-model/crew-dashboard';
import { signalStore, withComputed, withState } from '@ngrx/signals';
import { CREW_DASHBOARD_STORE_ID } from './constants';
import { buildCrewDashboardVm } from './crew-dashboard-vm-builder';
import { withCrewDashboardEffects } from './with-crew-dashboard-effects';
import { withCrewDashboardReducer } from './with-crew-dashboard-reducer';

export const CrewDashboardStore = signalStore(
  { providedIn: 'root' },
  withDevtools(CREW_DASHBOARD_STORE_ID, withGlitchTracking()),
  withState<CrewDashboardState>(INITIAL_CREW_DASHBOARD_STATE),
  withCrewDashboardEffects(),
  withCrewDashboardReducer(),
  withComputed((store) => {
    return {
      vm: computed(() => {
        const data = store.dashboardData();
        const selectedRange = store.selectedRange();
        return buildCrewDashboardVm(data, selectedRange);
      }),
    };
  })
);
